var React = require('react');

function DollyFlatbedAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M432 160h96a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zM368 32H208a16 16 0 0 0-16 16v256a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm224 160H432a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-96a16 16 0 0 0-16-16zM450.74 448a48 48 0 1 0 90.52 0zm-288 0a48 48 0 1 0 90.52 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640 400v32a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V64H16A16 16 0 0 1 0 48V16A16 16 0 0 1 16 0h96a16 16 0 0 1 16 16v368h496a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

DollyFlatbedAlt.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = DollyFlatbedAlt;

DollyFlatbedAlt.default = DollyFlatbedAlt;
